import React from "react";
import './monitoring.scss';
import {MonitorRoute} from "../../routes/MainRoute";

export default function Monitoring() {
    return <MonitorRoute/>
}